import React from 'react'
import FeedbackTable from '../components/Feedbacks/FeedbackTable'

const FeedbackScreen = () => {
   
  return (
    <FeedbackTable/>
  )
}

export default FeedbackScreen